module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "size": "lg",
      "visible": _vm.shown
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }), _vm._v(" "), _c('spend-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'SPEND_X_FOR_DISCOUNT' || _vm.type === 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || _vm.type === 'SPEND_GET_SUM_OFF_ITEMS',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('multi-buy', {
    attrs: {
      "shown": _vm.type === 'MULTI_BUY' || _vm.type === 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('buy-x-for-discount', {
    attrs: {
      "shown": _vm.type === 'BUY_X_FOR_DISCOUNT' || _vm.type === 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || _vm.type === 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  }), _vm._v(" "), _c('buy-x-for-y-off', {
    attrs: {
      "shown": _vm.type === 'MULTIBUY_X_FOR_DISCOUNT' || _vm.type === 'MULTIBUY_GET_SUM_OFF' || _vm.type === 'MULTIBUY_GET_PERCENTAGE_OFF',
      "value": _vm.promotion
    },
    on: {
      "hide": function($event) {
        _vm.type = null
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3c6c916d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/ViewPromotion.vue
// module id = 1681
// module chunks = 1